var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pref-mass-edit-input" },
    [
      _c(
        "el-form",
        {
          staticClass: "mb-0",
          attrs: { rules: _vm.pref.validator, model: _vm.modelForm }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "flex-column-content mb-0",
              attrs: {
                prop: _vm.pref.name,
                error: _vm.error.get(_vm.pref.name)
              }
            },
            [
              _c("p", [_vm._v(_vm._s(_vm.pref.label))]),
              _vm._v(" "),
              _vm.pref.component !== ""
                ? _c(
                    _vm.pref.component,
                    _vm._b(
                      {
                        tag: "component",
                        staticClass: "input-pref-mass-edit",
                        model: {
                          value: _vm.pref.value,
                          callback: function($$v) {
                            _vm.$set(_vm.pref, "value", $$v)
                          },
                          expression: "pref.value"
                        }
                      },
                      "component",
                      _vm.pref.data,
                      false
                    )
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }